import axios from "axios";

export default {
  base_url: "https://app.bhilwarahealthcare.in/api/method/",
  base_url_for_Image: "https://app.bhilwarahealthcare.in",

  api_key: "",
  api_secret: "",
  get_data(url, params = "") {
    this.validate_key();
    let requestOptions = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    if (this.api_key !== null || this.api_secret !== null) {
      requestOptions.headers["Authorization"] =
        "token " + this.api_key + ":" + this.api_secret;
    }

    return axios
      .get(this.base_url + url + "?" + params, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return alert(response.data.message);
        }
      })
      .catch((error) => {
        if (error.response.status == "403") {
          this.unauthorize_login();
        }
      });
  },

  post_data(url, params = "",guest_call=false) {
    let requestOptions = "";
    requestOptions = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
    };
    if(!guest_call) {
      this.validate_key();
      requestOptions.headers["Authorization"] = "token " + this.api_key + ":" + this.api_secret
    }
    
    return axios
      .post(this.base_url + url, params, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return alert(response.data.message);
        }
      })
      .catch((error) => {
        if (error.response) {
          return error.response.data.message;
        }
      });
  },
  validate_key() {
    this.api_key = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo")).api_key
      : null;
    this.api_secret = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo")).api_secret
      : null;

    if (this.api_secret == "" || this.api_key == "") {
      this.unauthorize_login();
    }
  },
  unauthorize_login() {
    localStorage.removeItem("userInfo");
    location.reload();
  },
};



// WEBPACK FOOTER //
// ./src/services/CommonApi.js